export function useClipboard() {
    function copyIntoClipboard(newClip) {
        return navigator.clipboard.writeText(newClip);
    }
    return { copyIntoClipboard };
}
